/* eslint-disable react/prop-types */
import React, { CSSProperties, Component } from 'react';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { InsertStateType } from '../../../editor/src/js/constants/common-action-type';
import {
    headEndInfoOfInsertLineType,
    lineTypeOfInsertShapeType,
    tailEndInfoOfInsertLineType,
} from '../../../../slide/infrastructure/module/dependent/line-info';
import sprite from './sprite.css';
import classNames from 'classnames';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { isPortrait } from '@src/js/common/utils';
import { ptToCanvas } from '../../../../slide/infrastructure/module/independent/unit';
import { SolidFill } from '../../../../slide/domain/ui-model/plugin/referModels/FillClass';
import set from 'lodash/set';
import { createDefaultTextStyle } from '@editor/src/page/index/components/canvas/utils';
import { dispatchResizeEvent } from '@frame-m/components/utils/dispatchResizeEvent';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import IpadPencilClickHelper from '@src/framework/frame-m/components/utils/ipad-pencil-click-helper';
import { TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model/src/ultrabuf/ultrabuf.types';
import { IMobileEditorAppServices } from '@src/slide/application/entry/toc/editor/mobile/mobile-editor-app-service.interface';
import Style from './index.less';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';

interface ItemIconProps {
    groupid?: string;
    type?: string;
    width: number;
    height: number;
    title: string;
    bg: any;
    hideMenu?: () => void;
    hideToolBar?: () => void;
    cropPicker?: boolean;
}

interface ItemIconState {
    tooltipVisible: boolean;
}

/**
 * shape菜单
 */
export default class ItemIcon extends Component<ItemIconProps, ItemIconState> {
    private ipadPencilClickHelper: IpadPencilClickHelper;
    public constructor(props, context) {
        super(props, context);
        if (browser.isIPad) {
            this.ipadPencilClickHelper = new IpadPencilClickHelper(this.onShapeItemClick);
        }
        this.state = {
            tooltipVisible: false,
        };
    }

    public render() {
        const styles: CSSProperties = {};
        if (isPortrait() && !browser.isWideScreenDevice) {
            const perIconMargin = Math.floor(((window.screen.width - 24) / 7) - 33) / 2;
            styles.marginLeft = perIconMargin;
            styles.marginRight = perIconMargin;
        }


        return  <div id={`${this.props.type}`} key={`${this.props.type}`} className={Style.sub}
            style={styles}
            onClick={this.onShapeItemClick}
            onTouchStart={this.ipadPencilClickHelper?.touchstart}
            onTouchMove={this.ipadPencilClickHelper?.touchmove}
            onTouchEnd={this.ipadPencilClickHelper?.touchend}
        >
            <span className={classNames(sprite.icon, sprite[`icon-${this.props.type}`])}/>
        </div>;
    }


    private insertShapeElement = (type) => {
        if (!this.getSelectionService()?.currentSlide) return;// sanzhiyang

        let data;
        if (this.props.groupid && this.props.groupid === 'connectorLine') {
            type = InsertStateType.CONNECTOR;
            data = {
                type: this.props.type,
                width: this.props.width,
                height: this.props.height,
                title: this.props.title,
                headEndType: 'triangle',
                tailEndType: 'triangle',
            };
        } else {
            type = InsertStateType.SHAPE;
            data = {
                type: this.props.type,
                width: this.props.width,
                height: this.props.height,
                title: this.props.title,
                bg: this.props.bg,
            };
        }
        this.getSelectionService().selectedElements.clear();
        this.getSelectionService().selectedSlides.clear();
        this.handleInsertActionFinish(data, type);
        dispatchResizeEvent({ scrollCenter: true }); // 插入形状后，使页面滚动到画布中心
    };

    private handleInsertActionFinish = (data, type) => {
        const { currentSlideIndex, slides } = this.getSelectionService();
        const slideModel = slides[currentSlideIndex];
        const current = {
            left: (this.getUiDataService().presentation.props.slideWidth / 2) - (ptToCanvas(data.width) / 2),
            top: (this.getUiDataService().presentation.props.slideHeight / 2) - (ptToCanvas(data.height) / 2),
        };
        let model: any = null;
        let isTransBg = false;
        let extraInfo;
        switch (type) {
            case InsertStateType.SHAPE:
                if (data.bg === 'trans') {
                    isTransBg = true; // 个别图形插入时没有背景
                }

                model = {
                    style: {
                        position: 'absolute',
                        left: current.left,
                        top: current.top,
                        bgShape: data.type,
                        border: { width: 1, color: '#5C5C5C', tdColor: new TDColor({ rgbaStr: '#5C5C5C' }) },
                        width: ptToCanvas(data.width),
                        height: ptToCanvas(data.height),
                    },
                };
                this.isFillBackground(isTransBg, model);
                extraInfo = createDefaultTextStyle();
                break;
            case InsertStateType.CONNECTOR:
                model = {
                    style: {
                        position: 'absolute',
                        left: current.left,
                        top: current.top,
                        bgLine: lineTypeOfInsertShapeType(data.type),
                        fillBackground: null,
                        border: { width: 2, color: '#000', tdColor: new TDColor({ rgbaStr: '#000000' }) },
                        width: ptToCanvas(data.width),
                        height: ptToCanvas(data.height),
                    },
                };
                // eslint-disable-next-line no-case-declarations
                const headEndType = headEndInfoOfInsertLineType(data.type);
                // eslint-disable-next-line no-case-declarations
                const tailEndType = tailEndInfoOfInsertLineType(data.type);
                set(model, 'style.border.headEnd.lineEndType', headEndType);
                set(model, 'style.border.tailEnd.lineEndType', tailEndType);
                break;
        }
        if (model) {
            if (type === InsertStateType.SHAPE) {
                slideModel.addElement([UIModelType.SHAPE], [model], [extraInfo]);
            } else if (type === InsertStateType.CONNECTOR) {
                slideModel.addElement([UIModelType.CONNECTOR], [model]);
            }
        }
        this.getEditingStateManager().clearInsertState();
        this.props.hideMenu?.();
    };

    private cropElement = () => {
        const selectArray = this.getSelectionService().selectedElements.selectedArray;
        if (selectArray?.length === 1) {
            (selectArray[0] as IPictureModel).getImageCrop?.().cropWithShape?.(this.props.type);
        }
    };

    private onShapeItemClick = () => {
        if (this.props.cropPicker) {
            this.cropElement();
        } else {
            this.insertShapeElement(UIModelType.SHAPE);
        }
        if (this.props.hideMenu) {
            this.props.hideMenu();
        }
        if (this.props.hideToolBar) {
            this.props.hideToolBar();
        }
    };

    private isFillBackground = (isTB, model) => {
        if (isTB) {
            set(model, 'style.fillBackground', null);
        } else {
            set(model, 'style.fillBackground', { solidFill: new SolidFill(new TDColor({ themeKey: STSchemeColorVal.accent1 })) });
        }
    };

    private getSelectionService() {
        return this.getAppServices().viewableServiceLayer?.selectionService;
    }

    private getUiDataService() {
        return this.getAppServices().getUiDataService();
    }

    private getEditingStateManager() {
        return this.getAppServices().viewableServiceLayer.editingStateManager;
    }

    private getAppServices() {
        return AppServiceProvider.getInstance().getAppServices() as IMobileEditorAppServices;
    }
}
